import {
  CreateHeyLightProductForm,
  CreateHeyLightProductFormValues,
} from "./CreateHeyLightProductForm.tsx";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { useKnownPurchaseAcTags } from "./useKnownPurchaseAcTags.ts";
import { useKnownRefundAcTags } from "./useKnownRefundAcTags.ts";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { useAllHeyLightProducts } from "./useAllHeyLightProducts.ts";
import { useCreateHeyLightProduct } from "./useCreateHeyLightProduct.ts";
import { useNavigate } from "react-router";
import { AdminHeyLightAllProductScreenPath } from "./AdminHeyLightAllProductScreen.tsx";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { KnownProduct } from "./KnownProduct.tsx";

export const CreateHeyLightProductScreenPath = "/admin/heylight/create-product";
export function CreateHeyLightProductScreen() {
  const { isLoading: isLoadingPurchaseTags, purchaseTags } =
    useKnownPurchaseAcTags();
  const { isLoading: isLoadingRefundTags, refundTags } = useKnownRefundAcTags();

  const { products, isLoading: isLoadingProducts } = useAllHeyLightProducts();

  const { createHeyLightProduct, loading: creating } =
    useCreateHeyLightProduct();

  const navigate = useNavigate();

  const loading =
    isLoadingPurchaseTags || isLoadingRefundTags || isLoadingProducts;

  const onSubmit = async (
    data: CreateHeyLightProductFormValues,
  ): Promise<void> => {
    await createHeyLightProduct({
      allowedTerms: data.allowedTerms,
      bundledProductIds: data.bundledProductIds ?? [],
      failureUrl: data.failureUrl,
      internalProductName: data.internalProductName,
      priceInCents: { amount: data.priceInEuros * 100, currency: "EUR" },
      productClass: data.productClass,
      productName: data.productName,
      purchaseAcTags: data.purchaseAcTags ?? [],
      refundAcTags: data.refundAcTags ?? [],
      successUrl: data.successUrl,
      peopleCount: data.peopleCount,
      fpsProductInfo:
        data.productClass === KnownProduct.FPS
          ? {
              durationInWeeks: data.fpsLessonsDurationInWeeks || 0,
              unlimitedLessonsPerWeek: data.fpsUnlimitedLessonsPerWeek || false,
              lessonsPerWeek: data.fpsLessonsPerWeek || 0,
              totalLessons: data.fpsTotalLessons || 0,
              extraWeek: data.fpsExtraWeek || false,
              warrantyEnabled: data.fpsWarrantyEnabled || false,
              warrantyMinAttendedLessons:
                data.fpsWarrantyMinAttendedLessons || 0,
              userGroupSlug: data.userGroupSlug,
              doNotEnroll: data.doNotEnroll,
              doNotMerge: data.doNotMerge,
            }
          : undefined,
      analyticsTag: data.analyticsTag,
    });
    navigate(AdminHeyLightAllProductScreenPath);
  };
  if (loading) return <FullPageLoading />;
  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className={"p-4 flex-1 flex items-center"}>
          <div
            className={
              "max-w-[1024px]  w-full mx-auto bg-white p-4 rounded-lg flex flex-col gap-4"
            }
          >
            <h1 className={"font-bold text-2xl"}>
              Crea nuovo prodotto HeyLight
            </h1>
            <CreateHeyLightProductForm
              onSubmit={onSubmit}
              products={products}
              creating={creating}
              initialKnownPurchaseAcTags={purchaseTags}
              initialKnownRefundAcTags={refundTags}
            />
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
